export default "__VITE_ASSET__CE8m4eHh__"